import {
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES,
    CONFIGURATION_TYPES
} from "shared/types/enums";

export const LABELS = {
    [CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.BluetoothAuthListSync]:
        CONFIGURATION_TYPES.BluetoothAuthorizationList,
    [CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.ManualGeofenceListSync]:
        CONFIGURATION_TYPES.ManualGeofenceList,
    [CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.MainConfigurationSync]:
        CONFIGURATION_TYPES.MainConfiguration,
    [CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.OneWireAuthListSync]:
        CONFIGURATION_TYPES.OneWireAuthorizationList
};
